import * as React from 'react';
import ArticleContainer from '../components/ArticleContainer';
import ContactForm from '../components/contact/contactForm';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const PrivacyPage = () => (
  <Layout>
    <ArticleContainer>
      <h1>Contact Us ✉️</h1>
      <p>
        Please don't hesitate to reach out to us through the contact form or at{' '}
        <a href="mailto:support@seatingchartmaker.app">
          support@seatingchartmaker.app
        </a>
        . We're always here to assist you! We'll respond to your queries as
        promptly as possible.
      </p>
      <p>
        Whether you're encountering an issue with Seating Chart Maker, wish to
        provide feedback, or have any other inquiries, we're all ears!
      </p>
      <ContactForm className="mt-10 not-prose" />
    </ArticleContainer>
  </Layout>
);

export const Head = () => (
  <SEO
    title="Seating Chart Maker | Contact Us"
    description="Reach out to Seating Chart Maker for assistance, feedback, or any inquiries. We aim to respond within 24 hours."
  />
);

export default PrivacyPage;
